import { isFooteHost } from "@/lib/footeHost";
import { FOOTE_PARTNER } from "@/lib/footeGate";
import { usePartnerHeartbeat } from "@/hooks/usePartnerHeartbeat";

/**
 * Mounts the partner usage heartbeat on partner platforms, and nowhere else.
 *
 * Sits beside AnalyticsTracker inside the router — both need `useLocation`,
 * and both must be mounted exactly once for the whole app.
 *
 * ⚠️ THE HOST CHECK IS THE SCOPE, AND IT IS DELIBERATELY NARROW.
 * This records a named business customer's use of a product they are paying
 * for — which is ordinary B2B product analytics, and is why it is limited to
 * partner platforms. It is NOT mounted on raisedbeef.com, the barn apps or the
 * lobby screens, where the people in front of it never signed up for anything
 * and in most cases are not signed in at all. Broadening it is a decision about
 * what the company is willing to collect, not a refactor; make it on purpose.
 *
 * Adding a second partner is one line here plus their host helper.
 */
export default function PartnerUsageTracker() {
  const partnerSlug = isFooteHost() ? FOOTE_PARTNER : null;
  usePartnerHeartbeat(partnerSlug);
  return null;
}
